import React, { useEffect, Fragment, useRef, } from 'react';
import { Button, } from 'reactstrap';
import { chunk, mapValues, orderBy, get, pick, omit, uniqBy, keyBy, } from 'lodash';
import { toast, } from 'react-toastify';
import { format as formatDate, } from 'date-fns';
import jsbarcode from 'jsbarcode';

import firebase from '../../firebase';
import { fields, statuses, boxSizes, deliveryTypes, deliveryType, } from '../../shared/models/shippingRequest';
import { idWithTenant, fieldDisplayValue, postalCodeWithHyphen, } from '../../shared/util';
import { deliveryTimes, prefectures, } from '../../shared/config';
import { newId } from '../../util';
import useQueryParams from '../hooks/useQueryParams';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import useDocumentsFetch from '../hooks/useDocumentsFetch';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import AdminPage from '../hocs/AdminPage';
import ShippingRequestFormModal from '../modals/ShippingRequestFormModal';
import ShippingRequestCsvFlowModal from '../modals/ShippingRequestCsvFlowModal';
import AddButton from '../AddButton';
import EditButton from '../EditButton';
import ExportButton from '../ExportButton';

const { entries } = Object;
const db = firebase.firestore();
const storageRef = firebase.storage().ref();
const tenantsRef = db.collection('tenants');
const shippingRequestsRef = db.collectionGroup('shippingRequests');
const statusesByLabel = mapValues(keyBy(entries(statuses), _ => _[1].label), '0');
const shippingRequestsCsvInfoRef = db.collection('settings').doc('shippingRequestsCsvInfo');
function AdminAmazonShippingRequestList (props) {
  const { ids: _ids } = useQueryParams();
  // NOTE: idsが21個以上になると、arrayでなくobjectとしてparseされてしまうのでObject.valuesを通す
  const ids = Object.values(_ids);
  const shippingRequests = useDocumentsFetch(ids.map(_ => tenantsRef.doc(_.tenantId).collection('shippingRequests').doc(_.shippingRequestId)), [JSON.stringify(ids)]);
  const tenants = useDocumentsFetch(uniqBy(shippingRequests.map(_ => _.ref.parent.parent), 'id'), [shippingRequests]);
  const tenantsById = keyBy(tenants, 'id');

  return (
    <div className="admin-amazon-shipping-request-list container-fluid bg-white">
      {
        shippingRequests.map(_ => <ListItem shippingRequest={_} />)
      }
    </div>
  );
}

function ListItem (props) {
  const { shippingRequest } = props;
  const canvasRef = useRef(null);
  const { postalCode, prefecture, city, address1, address2, name } = shippingRequest;
  useEffect(() => {
    if(canvasRef.current != null) {
      jsbarcode(canvasRef.current, shippingRequest.plan.ShipmentId);
    }
  }, [canvasRef.current]);

  return (
    <Fragment>
      <div className="d-flex align-items-center justify-content-center" style={{ height: 800 }}>
        <div className="card p-5">
          <div style={{ fontSize: 25 }}>
            {idWithTenant(shippingRequest.ref)}
          </div>
          <canvas ref={canvasRef} />
          <div className="mt-4 large">
            <div>
              {postalCode.slice(0, 3) + '-' + postalCode.slice(3)}
            </div>
            <div>
              {[prefectures[prefecture], city, address1].join('')}
            </div>
            <div>
              {address2}
            </div>
            <div>
              {name}
            </div>
          </div>
        </div>
      </div>
      <div className="pagebreak" />
    </Fragment>
  );
}

AdminAmazonShippingRequestList.forPrint = true;

export default AdminPage(AdminAmazonShippingRequestList);

